module.exports = {
  typography: {
    primary: 'Orbitron, sans-serif',
    secondary: 'Electrolize, sans-serif'
  },
  color: {
    accent: 0.2,
    alpha: 0.5,
    primary: {
      dark: '#bbbbbb',
      main: '#eeeeee',
      light: '#ffffff'
    },
    secondary: {
      dark: '#19a0b3',
      main: '#27e1fa',
      light: '#7eecfb'
    },
    tertiary: {
      dark: '#b5a005',
      main: '#fae127',
      light: '#feec67'
    },
    heading: {
      main: '#eeeeee'
    },
    text: {
      main: '#cccccc'
    },
    link: {
      dark: '#55cbd0',
      main: '#87f7fc',
      light: '#aff3f6'
    },
    background: {
      dark: '#000000',
      main: '#02161a',
      light: '#043b3b'
    }
  },
  animation: {
    time: 250,
    stagger: 50
  }
};
